import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { EmployerService } from '@/infra/services/employer';

interface GetEmployerParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = EmployerService.getInstance();

export const useGetEmployer = (params: GetEmployerParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id, params.id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_EMPLOYER, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
